import { useSuspenseQuery } from "@apollo/client";
import { GET_ENTITIES_NAME } from "../api/get-entities-name/get-entities-name";
import { NamedTypes } from "gql/graphql";
import { ReactNode } from "react";

export function useEntityName(
  id: string | null | undefined,
  entity: NamedTypes,
) {
  const { data } = useSuspenseQuery(GET_ENTITIES_NAME, {
    fetchPolicy: "network-only",
    skip: !id || !entity,
    variables: {
      namesQuery: {
        items: [
          {
            id: id as string,
            entity,
          },
        ],
      },
    },
  });

  return data?.getNamedTypeNames[0].name ?? "";
}

export function EntityName({
  entity,
  id,
  children,
}: {
  id: string | null | undefined;
  entity: NamedTypes;
  children: (name: string) => ReactNode;
}) {
  const entityName = useEntityName(id, entity);

  return <>{children(entityName)}</>;
}
